import { createTheme, Theme } from "@mui/material/styles";
import type {} from "@mui/x-date-pickers/themeAugmentation";

declare module "@mui/material/styles" {
  interface PaletteColor {
    gradient?: string;
  }

  interface SimplePaletteColorOptions {
    gradient?: string;
  }
}

const theme: Theme = createTheme({
  palette: {
    primary: {
      main: "#2B378B",
      dark: "#25293A",
      light: "#F0F5FA",
    },
    secondary: {
      main: "#FF7F00",
      gradient: "linear-gradient(135deg,  #FF9347 0%, #FF6232 100%)",
    },
    text: {
      primary: "#424750",
    },
  },
  typography: {
    fontFamily: ["Noto Sans JP", "sans-serif"].join(","),
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          lineHeight: 1,
          color: "#fff",
          fontSize: "18px",
          fontWeight: 700,
          borderRadius: "8px",
          padding: "20px",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          height: "1rem",
          padding: "8.5px 12px",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          padding: 0,
        },
        input: {
          padding: "8.5px 12px",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input.MuiAutocomplete-input": {
            padding: 0,
          },
        },
        inputRoot: {
          padding: "8.5px 12px",
        },
      },
    },
    MuiPickersInputBase: {
      styleOverrides: {
        root: {
          padding: "0 12px !important",
        },
        sectionsContainer: {
          padding: "8.5px 0 !important",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          margin: 0,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          fontWeight: 700,
          color: "#222222",
          marginBottom: "8px",
          "&.Mui-focused": {
            color: "#222222",
          },
        },
      },
    },
    MuiCardMedia: {
      styleOverrides: {
        root: {
          height: 180,
        },
      },
    },
  },
});

export default theme;
